import Dictionary from "../../models/Dictionary";

type TestLocation = TestRequestRaw.Schemas.TestLocation;

export const testLocationDictionary: Dictionary<TestLocation> = {
  CSC_LAB: "CSC Lab",
  THIRD_PARTY_LAB: "3rd Party Lab",
};

export default TestLocation;
